import type { NoteDef } from './notes';

/** Distância (px) entre duas linhas da pauta na escala padrão. */
export const STAFF_SPACE = 20;

/** Posições (em espaços de pauta) das cinco linhas; linha de Sol = 0. */
export const STAFF_LINE_STEPS = [-1, 0, 1, 2, 3];

/** Linha de Sol (G4) é a segunda linha de baixo para cima. */
export const G_LINE_STEP = 0;

/**
 * Traçado vetorial da clave de sol (desenhado em unidades de espaço da pauta,
 * com a origem no centro do enrolamento / linha de Sol). Reutilizado pelo
 * pentagrama de notas e pela pauta rítmica.
 */
export const TREBLE_CLEF_PATH =
  'M -1.5 3.2 C -2.0 2.7 -1.2 2.0 -0.6 1.9 C -0.1 0.8 0.15 -1.0 0.1 -2.2 ' +
  'C 0.4 -3.3 -0.9 -4.0 -1.5 -3.0 C -2.0 -2.1 -1.4 -1.0 -0.5 -0.9 ' +
  'C 0.5 -0.8 1.4 -0.3 1.5 0.8 C 1.6 1.9 0.6 2.6 -0.3 2.2 ' +
  'C -1.0 1.9 -1.1 1.0 -0.6 0.5 C -0.1 0.05 0.6 0.3 0.2 0.6';

export interface StaffGeometry {
  /** posição vertical (px) da linha de Sol */
  gLineY: number;
  /** distância entre linhas (px) já considerando a escala */
  space: number;
}

export function stepToY(step: number, geometry: StaffGeometry): number {
  return geometry.gLineY - step * geometry.space;
}

export function isOnLine(step: number): boolean {
  return Number.isInteger(step);
}

/** Notas que exigem linha suplementar (fora das 5 linhas). */
export function needsLedger(step: number): boolean {
  return step < -1 || step > 3;
}

/**
 * Ponto de referência usado para desenhar a linha suplementar:
 * para C4 (step -2) a linha fica no próprio centro da nota.
 */
export function ledgerSteps(step: number): number[] {
  const steps: number[] = [];
  if (step <= -2) {
    for (let s = -2; s >= step; s -= 1) {
      if (Number.isInteger(s)) steps.push(s);
    }
  }
  if (step >= 4) {
    for (let s = 4; s <= step; s += 1) {
      if (Number.isInteger(s)) steps.push(s);
    }
  }
  return steps;
}

export function noteDisplay(note: NoteDef): string {
  return note.label;
}